import React from 'react';
import { TypedMemo } from '../../../common/types';
import { useWorkspaces } from '../../../workspaces/useWorkspaces';
import { useDefaultWorkspaceName } from '../../../workspaces/useDefaultWorkspaceName';

interface AccountWorkspaceNameProps {
  email: string;
}

/**
 * design: navigation-v2 1e. The name of the active workspace on the account card of a workspace
 * with 2 or more artists: its own name, else the default name, else the email. Only that card
 * reads `workspaces.list`, so a 1-artist card asks for nothing.
 */
const AccountWorkspaceNameComponent: React.FC<AccountWorkspaceNameProps> = ({ email }) => {
  const workspace = useWorkspaces().active;
  const defaultName = useDefaultWorkspaceName(email === '' ? null : email);
  return <>{workspace?.name ?? defaultName ?? email}</>;
};

export const AccountWorkspaceName = TypedMemo(AccountWorkspaceNameComponent);
